/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, TemplateRef } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { GridFeature, GridFeatureInitParams, GridFeatureReadyParams } from '../feature.interfaces';
import { GridNoRowsOverlayTemplateComponent } from './grid-no-rows-overlay-template.component';

@Directive({
  standalone: false,
  selector: '[ghGridNoRowsOverlay]',
})
export class GridNoRowsOverlayDirective implements GridFeature {
  constructor(private templateRef: TemplateRef<any>) {
  }

  enhanceGridOptions(options: GridOptions): void {
    options.noRowsOverlayComponent = GridNoRowsOverlayTemplateComponent;
    options.noRowsOverlayComponentParams = { templateRef: this.templateRef };
  }

  initGrid(params: GridFeatureInitParams): void {
    // nothing to do
  }

  onDestroy(): void {
    // nothing to do
  }

  onGridReady(params: GridFeatureReadyParams): void {
    // nothing to do
  }

  getFeature(): GridFeature {
    return this;
  }
}
